<template>
  <div
    class="flex h-full items-center w-full py-4 hover:bg-slate-50 transition-colors duration-200 cursor-pointer group"
    @click="
      $bus.emit($constants.EVENTS.TRANSACTIONS.DETAILS_REQUESTED, $attrs.item)
    "
  >
    <div class="flex gap-4 items-center w-full px-2">
      <!-- Logo with status badge -->
      <div class="relative flex-shrink-0">
        <div class="w-16 h-16 rounded-2xl bg-white shadow-sm p-2 shimmerTarget flex items-center justify-center border border-slate-100 group-hover:shadow-md transition-shadow">
          <ImgComponent
            :src="$attrs.item?.logo"
            alt=""
            class="w-full h-full object-contain"
          />
        </div>
        <div
          class="absolute -bottom-1.5 -right-1.5 w-7 h-7 rounded-lg flex items-center justify-center shadow-sm"
          :class="{
            'bg-emerald-500': $attrs.item?.operation == 'fund',
            'bg-rose-500': $attrs.item?.operation == 'withdraw'
          }"
        >
          <ColorImg
            src="/images/icons/arrow-up.svg"
            alt=""
            class="w-4 h-4 bg-white"
            :class="{
              'rotate-30': $attrs.item?.operation == 'fund',
              'rotate-210': $attrs.item?.operation == 'withdraw'
            }"
          />
        </div>
      </div>

      <!-- Info -->
      <div class="flex flex-col items-start flex-1 min-w-0">
        <div class="font-semibold text-lg shimmerTarget text-gray-900 truncate">
          {{ $attrs.item?.operationNameDisplay }}
        </div>
        <div class="description-color shimmerTarget text-sm mt-1 flex items-center gap-1.5">
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {{ $attrs.item?.startDate }}
        </div>
      </div>

      <!-- Amount -->
      <div class="ml-auto text-right flex flex-col items-end gap-1">
        <div
          class="font-bold text-xl shimmerTarget"
          :class="{
            'text-emerald-600': $attrs.item?.operation == 'fund',
            'text-rose-600': $attrs.item?.operation == 'withdraw'
          }"
        >
          {{
            $attrs.item?.operation == 'fund'
              ? '+'
              : $attrs.item?.operation == 'withdraw'
              ? '-'
              : ''
          }}
          {{ formatAmount($attrs.item?.amountToReceive) }}
        </div>
        <div class="text-sm text-gray-500">CFA</div>
      </div>

      <!-- Arrow -->
      <div class="w-8 h-8 rounded-xl bg-slate-100 group-hover:bg-indigo-100 flex items-center justify-center transition-colors ml-3 flex-shrink-0">
        <svg class="w-4 h-4 text-gray-400 group-hover:text-indigo-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    formatAmount(amount) {
      if (!amount) return '0';
      return parseInt(amount).toLocaleString('fr-FR');
    }
  }
};
</script>
